import { useBreakpoint } from "@amzn/aws-euc-ui";
import { useEffect, useLayoutEffect } from "react";
import { getLegacyFlag, getMobileDeviceFlag } from "../utils/toolbarItemUtils";
import { SetCookiesFromUrlParamsStatus } from "./useSetCookiesFromUrlParams";
import { isDeviceOnExperimentalMode } from "../utils/userAgentUtils";
import { ClassName } from "../constants/styles";
import classNames from "classnames";
import { useInitializeCustomBranding } from "./customBranding/useInitializeCustomBranding";
import { useCustomBrandingAssetStore } from "./customBranding/useCustomBrandingAsset";

interface AppInitializationProps {
    settingCookiesFromUrlParamsStatus: SetCookiesFromUrlParamsStatus;
}

export const useAppInitialization = (props: AppInitializationProps) => {
    const { isDesktopOrLaptop } = useBreakpoint();

    useLayoutEffect(() => {
        // TODO For mobile users, present the legacy experience until we can resolve the on-screen keyboard issue. (https://issues.amazon.com/issues/LOWA-11655)
        const isLegacy = getLegacyFlag() || isDeviceOnExperimentalMode();
        const isMobileFlagOn = getMobileDeviceFlag();
        const shouldUseLegacy = isLegacy && !isMobileFlagOn;
        const body = document.getElementsByTagName("body")[0];

        body.className = classNames(body.className, {
            [ClassName.LEGACY_BODY_BACKGROUND_STYLE]: shouldUseLegacy,
            [ClassName.EUC_BODY_BACKGROUND_STYLE]: !shouldUseLegacy,
        });
    }, [props.settingCookiesFromUrlParamsStatus]);

    useLayoutEffect(() => {
        document.documentElement.className = classNames(
            document.documentElement.className,
            {
                [ClassName.DESKTOP_LAPTOP_DEVICE_TYPE]: isDesktopOrLaptop,
                [ClassName.MOBILE_TABLET_DEVICE_TYPE]: !isDesktopOrLaptop,
            }
        );
    }, [isDesktopOrLaptop]);

    const isCustomBrandingResourceReady = useInitializeCustomBranding();
    const setIsResourceReady = useCustomBrandingAssetStore(
        (store) => store.setIsResourceReady
    );
    useEffect(() => {
        setIsResourceReady(isCustomBrandingResourceReady);
    }, [isCustomBrandingResourceReady]);
};
